module.exports = __webpack_public_path__ + "img/材料力学6_1_3.9e677c94.jpg";